/* eslint no-param-reassign: "error" */

export default [
  {
    id: 'start',
    clear: true,
    content: `
    Bonjour ! Vous allez vivre une semaine agitée !
    En fonction de vos réponses, vous allez passer une bonne semaine ou voir votre temps sacrément compromis.
    Prêtez-vous au jeu !

    Pour commencer, êtes-vous un homme ou une femme ?
    `,
    choices: ['gender_woman', 'gender_man', 'gender_secret'],
  },
  {
    id: 'gender_woman',
    optionText: 'Une femme',
    enter(model) {
      model.character('me').setQuality('gender', 'femme')
    },
    content: `
      Merci ! [Continuer](@lundi)
    `,
  },
  {
    id: 'gender_man',
    optionText: 'Un homme',
    enter(model) {
      model.character('me').setQuality('gender', 'homme')
    },
    content: `
      Merci ! [Continuer](@lundi)
    `,
  },
  {
    id: 'gender_secret',
    optionText: 'C’est top secret',
    enter(model) {
      model.character('me').setQuality('gender', 'secret')
    },
    content: `
      Merci ! [Continuer](@lundi)
    `,
  },
]
